// extracted by mini-css-extract-plugin
export default {"container":"FeaturedRiver_container__WUw1o"};